import React from 'react'
import ReportWrapper from '../ReportWrapper'
import ReportSectionHeading from '../ReportSectionHeading'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'
import dayjs from 'dayjs'
import TianyanchaRecordCard from '../TianyanchaRecordCard'

interface AbnormalItem {
  putReason: string
  putDepartment: string
  putDate: string
  removeDate: string
  removeDepartment: string
  removeReason: string
}

interface Props {
  data: any
  title: string
  sectionIndex?: string
}

const normalizeItems = (items: AbnormalItem[] = []) =>
  items.map((item) => ({
    reason: item.putReason || '—',
    department: item.putDepartment || '—',
    putDate: item.putDate ? dayjs(item.putDate).format('YYYY-MM-DD') : '—',
    removeDate: item.removeDate ? dayjs(item.removeDate).format('YYYY-MM-DD') : '—',
    removeDepartment: item.removeDepartment || '—',
    removeReason: item.removeReason || '—',
  }))

export default function TianyanchaAbnormal({ data, title, sectionIndex }: Props) {
  let jsonData: any
  try {
    jsonData = JSON.parse(data.tianyancha_abnormal ?? '{}')
  } catch (error) {
    jsonData = {}
  }

  const records = normalizeItems(jsonData.items)
  const theme = useTheme()

  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <div className="mt-2">
        <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
          经营异常信息
        </Text>
        <Stack gap="sm" className="mt-3">
          {records.length === 0 ? (
            <Text c="dimmed" size="sm" ta="center">
              暂无经营异常记录
            </Text>
          ) : (
            records.map((item, index) => (
              <TianyanchaRecordCard
                key={`${item.reason}-${index}`}
                number={index + 1}
                recordType="异常记录"
                fields={[
                  { label: '列入原因', value: item.reason },
                  { label: '列入机关', value: item.department },
                  { label: '列入日期', value: item.putDate },
                  { label: '移出日期', value: item.removeDate },
                  { label: '移出机关', value: item.removeDepartment },
                  { label: '移出原因', value: item.removeReason },
                ]}
              />
            ))
          )}
        </Stack>
      </div>
    </ReportWrapper>
  )
}
